import React from 'react'

import Messages from './ShaedMessages'
import Question from './SHaredQuestion'

interface StepperProps {
  activeStep: number
  subSearchArray: any[] // Replace with the actual type of your subSearchArray
  handleStepChange: (step: number) => void
}

const Stepper = ({ activeStep, subSearchArray, handleStepChange }: StepperProps) => {
  return (
    <>
      <div>
        <Question
          question={subSearchArray[activeStep]?.SearchTitle}
          questionId={subSearchArray[activeStep]?.id}
          index={activeStep}
          // setAiStorage={setAiStorage} // Pass the necessary props
        />
        <Messages
          answer={subSearchArray[activeStep]?.SearchResult}
          historyId={subSearchArray[activeStep]?.id}
        />
      </div>
    </>
  )
}

export default Stepper
